<template>
	<div class="instruction">
		<template v-if="isPreview">
			<svg svg-inline="" class="instruction__eye" focusable="false" role="presentation" viewBox="0 0 53 27" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="1.414"><path d="M.263 13.503v-.006H0C8.159 4.499 17.087 0 26.784 0 36.48 0 45.219 4.499 53 13.497h-.222v.006H53C45.219 22.501 36.48 27 26.784 27 17.087 27 8.159 22.501 0 13.503h.263z" fill="#ff7f1e"/><path d="M20.166 12.477a4.29 4.29 0 1 0 5.311-5.311 7 7 0 1 1-5.311 5.311z" fill="#691e25"/></svg>
			<span>This is how the information will look when you send it.</span>
		</template>
		<template v-else>
			<svg svg-inline="" focusable="false" role="presentation" width="25" height="24" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M16.575 16.375v-3.25H7.367v3.25h9.208zM7.367 7.708v3.25h9.208v-3.25H7.367z" fill="#EC6600"/><path d="M5.2 5h13v13h-13z"/><g fill="#EC6600"><path d="M.2 0h24v24H.2V0zm0 0h24v24H.2V0z"/><path d="M7.67 21.49C4.4 19.93 2.06 16.76 1.7 13H.2c.51 6.16 5.66 11 11.95 11 .23 0 .44-.02.66-.03L9 20.15l-1.33 1.34zM12.25 0c-.23 0-.44.02-.66.04l3.81 3.81 1.33-1.33C20 4.07 22.34 7.24 22.7 11h1.5c-.51-6.16-5.66-11-11.95-11z"/></g></g></svg>
			<span>Re-order and remove pieces of content below.</span>
		</template>
	</div>
</template>

<script>
export default {
	props: ['isPreview']
};
</script>
